import detail from './detail';
const management = [
  {
    path: '/vacation/management/revise',
    component: () => import('@/page/vacation/management/Revise.vue'),
    meta: {
      name: '전체 연차 수정',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/vacation/management/detail',
    component: () => import('@/page/vacation/management/Detail.vue'),
    redirect: '/vacation/management/detail/current/:id',
    children: [...detail],
    meta: {
      name: '상세 페이지',
      isActive: false,
      isBread: false,
    },
  },
];

export default management;
